import api from '@/api/nav'
import { asyncMenus, commonMenus } from '@/router/menus'
import { flatDeep, getFilterAsyncMenus, getFilterCommonMenus } from '@/utils/utils'

export default {
  namespaced: true,
  state: {
    /* nav */
    // 一级菜单列表
    levelOneList: [],
    // hover过程中的二级菜单列表（可能有多个，而且是动态变化的），下面的sidebarList只会有一个
    levelTwoList: [],
    // 一级菜单激活Id
    activeLevelOneId: '',
    // 二级菜单激活Id
    activeLevelTwoId: '',
    // 三级菜单激活Id
    activeLevelThreeId: '',
    // 一级菜单移入Index
    hoverLevelOneIndex: 0,
    // 一级菜单移入Id
    hoverLevelOneId: '',
    // 展示弹框
    showMask: false,
    /* sidebar */
    sidebarList: [],
    /* breadcrumb */
    matchedRoutes: []
  },
  mutations: {
    SET_ALL: (state, data) => {
      for (const [key, val] of Object.entries(data)) {
        state[key] = val
      }
    }
  },
  actions: {
    setMenus ({ state, commit }, { userRightType }) {
      return api.getTaskTree().then(res => {
        let { taskInfoName: taskInfoStr } = res
        while (taskInfoStr.indexOf('#') >= 0) {
          taskInfoStr = taskInfoStr.replace('#', '"')
        }
        while (taskInfoStr.indexOf('*') >= 0) {
          taskInfoStr = taskInfoStr.replace('*', ':')
        }
        // 旧企业网银: navList + 固定菜单
        const navList = JSON.parse(taskInfoStr)
        const previousMenus = [
          ...navList
        ]
        // 把企业网银旧菜单flat化
        const flatPreviousMenus = flatDeep(previousMenus)
        // 过滤下异步路由
        const filterAsyncMenus = getFilterAsyncMenus(asyncMenus, flatPreviousMenus)
        // 普通用户0 管理员1 下列四个固定菜单 普通用户不展示
        const filterIds = userRightType === '0' ? [
          { id: '10700600', label: '账户限额设置' },
          { id: '10700500', label: '企业管理授权' },
          { id: '10700000', label: '用户号维护' },
          { id: '10700800', label: '密码重置审批' }
        ] : []
        const filterCommonMenus = getFilterCommonMenus(commonMenus, filterIds)
        const levelOneList = [
          {
            path: '/home',
            name: 'Home',
            meta: {
              title: '首页'
            }
          },
          ...filterAsyncMenus,
          ...filterCommonMenus
        ]
        commit('SET_ALL', { levelOneList })
      }).catch(_ => console.warn(_))
    }
  }
}
